import { Mixin } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Mixin
class SearchMixin extends Vue {
    protected searchString = '';
    protected remainingTime = 800;
    protected searchTimeout!: any;

    public searchCallback() {
        // tslint:disable-next-line:no-console
        console.log('implement me!');
    }

    protected delaySearch() {
        const tempRemainingTime = this.remainingTime;
        if (this.searchString === '') {
            this.remainingTime = 0;
        }
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.searchCallback();
            this.remainingTime = tempRemainingTime;
        }, this.remainingTime);
    }

}

export default SearchMixin;
